import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderConditionPipe } from './order-condition.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    OrderConditionPipe
  ],
  exports: [
    OrderConditionPipe
  ]
})
export class OrderConditionModule { }
